import { APIConfiguration } from '@savgroup-front-common/configuration';
import {
  COMMON_QUERY_PARAMS,
  SUPPORTED_METHODS,
} from '@savgroup-front-common/constants';
import { prepareResponseFailure } from '@savgroup-front-common/core/helpers';
import { apiCall } from '@savgroup-front-common/core/services';
import {
  BackResponse,
  BackResponseFailure,
  DateTimeFilter,
  SearchFilterFacet,
} from '@savgroup-front-common/types';

import { ImportVersionWithUserDetailsDto } from './getVersionsQuery';

const ENDPOINT = `${APIConfiguration.import}sellers/${COMMON_QUERY_PARAMS.SELLER_ID}/importversions`;

export const ENTITIES_OR_RULES_CONTENT = {
  BOTH: 'Both',
  RULES_ONLY: 'RulesOnly',
  ENTITIES_ONLY: 'EntitiesOnly',
} as const;

export type EntitiesOrRulesContent =
  (typeof ENTITIES_OR_RULES_CONTENT)[keyof typeof ENTITIES_OR_RULES_CONTENT];

interface GetFilteredVersionsCommandArgs {
  sellerId: string;
  page?: number;
  pageSize?: number;
  filters?: SearchFilterFacet[];
  dateTimeFilters?: DateTimeFilter[];
  selectedContent?: EntitiesOrRulesContent;
}

const getFilteredVersionsCommand = async ({
  sellerId,
  page,
  pageSize,
  filters,
  dateTimeFilters,
  selectedContent,
}: GetFilteredVersionsCommandArgs): Promise<
  BackResponseFailure | BackResponse<ImportVersionWithUserDetailsDto[]>
> => {
  try {
    const url = ENDPOINT.replace(COMMON_QUERY_PARAMS.SELLER_ID, sellerId);

    return await apiCall<BackResponse<ImportVersionWithUserDetailsDto[]>>(url, {
      method: SUPPORTED_METHODS.POST,
      json: {
        page,
        pageSize,
        filters,
        dateTimeFilters,
        selectedContent,
      },
    });
  } catch (exception) {
    return prepareResponseFailure(exception);
  }
};

export default getFilteredVersionsCommand;
